import { render, staticRenderFns } from "./profile-business.vue?vue&type=template&id=bcd5b986&"
import script from "./profile-business.vue?vue&type=script&lang=js&"
export * from "./profile-business.vue?vue&type=script&lang=js&"
import style0 from "./profile-business.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports